import * as React from 'react';
import './buttonloader.scss';
import CircularProgress from '@mui/material/CircularProgress';
export default function SimpleBackdrop() { 
  return (
    <div className='loading_div' >
        <CircularProgress 
        size={20}

        className='loading' color="white" />
    </div>
  );
}
